import Node from 'ln/node/Node';
import View from 'ln/view/View';
import { scanner } from 'ln/view/Scanner';


class DropDown extends View {
	
	public cssClass:string;
	private documentHandler:( event ) => void;
	

	constructor( cssClass:string = 'open' ) {

		super( {} );

		this.cssClass = cssClass;
		
		this.documentHandler = this.close.bind( this );
	}
	
	init() {
		this.menuToggle.click.add( this.toggle, this );
	}
	
	open() {
		this.node.addClass( this.cssClass );
		document.addEventListener( 'click', this.documentHandler )
	}
	
	close() {
		this.node.removeClass( this.cssClass );
		document.removeEventListener( 'click', this.documentHandler );
	}

	toggle( node:Node, event:Event ) {
		event.stopImmediatePropagation();
		if( this.node.hasClass( this.cssClass ) ) {
			this.close();
		} else {
			this.open();
		}
	}

	get menuToggle():Node {
		return this.node.one( '.menu-toggle' );
	}
	get menuItems():Node {
		return this.node.one( '.menu-items' );
	}
}

export default DropDown;

scanner.ioc.add( 'drop-down', function( node ) {
	return new DropDown( node.data.css ).render( node );
});